import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { TimelineSegmentItem, TimelineService } from '@splixer/player';
import { MiniTrackCardComponent } from '../track-cards/mini/mini-track-card.component';

@Component({
  selector: 'kexp-mini-playlist',
  imports: [
    MiniTrackCardComponent
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: 'mini-playlist.component.html'
})
export class KexpMiniPlaylistComponent {
  protected timeline = inject(TimelineService);

  protected recentTracks = computed(() => {
    const trackItems: TimelineSegmentItem [] = [];
    let tracksFound = 0;
    const ci = this.timeline.nowPlayingItem();
    const cs = this.timeline.nowPlayingSegment();
    if (ci && cs) {
      for(const si of this.timeline.currentTimelineItems()) {
        if (si.type  === 'SegmentItem' && si.item?.content?.contentType !== 'MicBreak') {
          trackItems.push(si.item);
          tracksFound++;
          if (tracksFound > 4) {
            break;
          }
        }
      }
    }
    return trackItems;
  })
}
